import { ActionTypeList } from '../../constants/index'

const initialSubmissionState = {
    loading: false,
    isTargetAuthenticationTestSubmitted: false,
    error: "",
};

export const targetAuthenticationTestSubmissionPayload = (state = initialSubmissionState, action) => {

    let response = {};

    switch (action.type) {
        case ActionTypeList.TARGET_SETTING_AUTHENTICATION_TEST_SUBMITTED:
            response = {
                loading: false,
                isTargetAuthenticationTestSubmitted: true,
                testId: action.payload.testId,
                error: ""
            };
            break;
        case ActionTypeList.TARGET_SETTING_SUBMIT_AUTHENTICATION_TEST:
            response = {
                loading: true,
                error: action.payload.data.error
            };
            break;
        case ActionTypeList.TARGET_SETTING_AUTHENTICATION_TEST_RESULT_RESET:
            response = {
                loading: false,
                isTargetAuthenticationTestSubmitted: false,
                error: ""
            };
            break;
        default:
            response = state;
            break;
    }


    return response;
}


const initialCancellationSubmissionState = {
    loading: false,
    isTargetAuthenticationTestCancellationSubmitted: false,
    error: "",
};

export const targetAuthenticationTestCancellationSubmissionPayload = (state = initialCancellationSubmissionState, action) => {

    let response = {};

    switch (action.type) {
        case ActionTypeList.TARGET_SETTING_AUTHENTICATION_TEST_CANCELLATION_SUBMITTED:
            response = {
                loading: false,
                isTargetAuthenticationTestCancellationSubmitted: true,
                error: ""
            };
            break;
        case ActionTypeList.TARGET_SETTING_SUBMIT_AUTHENTICATION_TEST_CANCELLATION:
            response = {
                loading: true,
                error: action.payload.data.error
            };
            break;
        case ActionTypeList.TARGET_SETTING_AUTHENTICATION_TEST_RESULT_RESET:
        case ActionTypeList.TARGET_SETTING_AUTHENTICATION_TEST_SUBMITTED:
            response = {
                loading: false,
                isTargetAuthenticationTestCancellationSubmitted: false,
                error: ""
            };
            break;
        default:
            response = state;
            break;
    }

    return response;
}

const initialResultState = {
    loading: false,
    targetAuthenticationTestResult: {},
    error: "",
};

export const targetAuthenticationTestResultPayload = (state = initialResultState, action) => {

    let response = {};

    switch (action.type) {
        case ActionTypeList.TARGET_SETTING_AUTHENTICATION_TEST_RESULT_GOTTEN:
            response = {
                loading: false,
                targetAuthenticationTestResult: action.payload,
                error: ""
            };
            break;
        case ActionTypeList.TARGET_SETTING_GET_AUTHENTICATION_TEST_RESULT:
            response = {
                loading: true,
                error: action.payload.data.error
            };
            break;
        case ActionTypeList.TARGET_SETTING_AUTHENTICATION_TEST_RESULT_RESET:
        case ActionTypeList.TARGET_SETTING_AUTHENTICATION_TEST_SUBMITTED:
            response = {
                ...state,
                targetAuthenticationTestResult: {}
            }
            break;
        default:
            response = state;
            break;
    }

    return response;

}